import useApi from 'common/hooks/useApi';
import React, { useEffect } from 'react';

interface ICodeTableOptions {
  endpoint: string;
  avoidToken?: boolean;
  filter?: (o: CodeTableEntry) => boolean;
  includeEmpty?: boolean;
  emptyText?: string;
}

export type CodeTableEntry = { cd: string; descr: string };

const CodeTableOptions = (props: ICodeTableOptions) => {
  const [{ data: unfiltered }, request] = useApi<{ items: CodeTableEntry[] }>({
    url: '/codeTables' + props.endpoint,
    method: 'GET',
    bypassTokenCheck: props.avoidToken || false,
  });

  useEffect(() => {
    request();
  }, [request]);

  const { filter } = props;
  const filtered = filter
    ? unfiltered?.items.filter(filter)
    : unfiltered?.items;

  return (
    <>
      {props.includeEmpty && (
        <option value=''>{props.emptyText || '--'}</option>
      )}
      {filtered &&
        filtered.map((e) => (
          <option key={e.cd} value={e.cd}>
            {e.descr}
          </option>
        ))}
    </>
  );
};

export default CodeTableOptions;
